import Country from 'country-list-js'

const getAllCountries = () => {
  const countryArr = Object.entries(Country.all)
  return countryArr
    .map(x => x[1])
    .sort((a, b) => {
      const nameA = a.name.toUpperCase()
      const nameB = b.name.toUpperCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
}

const getCountryCode = countryName => {
  const {
    code: { iso3 }
  } = Country.findByName(countryName)
  return iso3
}

const getCountryObj = countryCode => {
  return Country.findByIso3(countryCode)
}

const getContinent = countryName => {
  const { continent } = Country.findByName(countryName)
  return continent
}

export { getAllCountries, getCountryCode, getCountryObj, getContinent }
